import CustomComponent from './components/CustomComponent.vue';
import RecentlyActivity from './components/RecentlyActivity.vue';

// 自定义组件映射
const CustomComponentMap = {
    CustomComponent: CustomComponent,
    RecentlyActivity: RecentlyActivity,
};

export { CustomComponentMap };
